import { AnyObject, CardStructureConfig, ItemAttrListDataSet, ItemBodyRender } from '@mri/types';

export function cardGetBodyRender(prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): Array<ItemBodyRender> {
  return structure.body(prop);
}